var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtendedReality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "abe86530-b62d-4d68-a065-313b347deeba",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .be4af604-07dd-4b91-ac2d-f98fab313d19 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "be4af604-07dd-4b91-ac2d-f98fab313d19",
    d: "M46,22.583,34.8,25.825,35.391,38.8,46,45.305,56.605,38.8l.6-12.974ZM53.586,26.4l-7.565,2.167-7.534-2.189L46,24.2Zm-17.161,1,8.8,2.555V43l-8.315-5.1ZM46.776,43V29.965l8.794-2.518L55.09,37.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be4af604-07dd-4b91-ac2d-f98fab313d19",
    d: "M33.429,38.956H32.67V18.7H67.33V38.956H58.64l-6.153,4H67.7a3.633,3.633,0,0,0,3.633-3.633V18.328A3.633,3.633,0,0,0,67.7,14.7H32.3a3.633,3.633,0,0,0-3.633,3.633v21A3.633,3.633,0,0,0,32.3,42.956h7.138Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedReality);
export default __webpack_public_path__ + "static/media/ExtendedReality.9b5384d96675e7ae6ead88623dd04a2b.svg";
export { ForwardRef as ReactComponent };